/**
 * The icon sets a photographer can pick for a gallery.
 *
 * `id` is the product-facing value: it is what gets persisted as `design.iconSet`
 * and what the API sees. `source` is the folder under
 * `src/assets/img/icons/icon-set-previews/`, named after the upstream library the
 * icons came from.
 *
 * The builder only stores the choice and previews five icons per set. The full
 * library — all 146 icons, the manifest and the fetch script — lives in the
 * galleries project (`scrappbook-gallerys`, `src/assets/icons/`), which is what
 * actually renders galleries with the chosen set.
 *
 * The two are kept separate so the stored value never leaks a vendor name, and so a
 * future set can reuse a library in a different weight (an "outline"/"filled" pair
 * from the same source, say) without a naming clash.
 */
export const ICON_SETS = [
  { id: 'minimal', source: 'feather', labelKey: 'collectionDesign.iconSetMinimal' },
  { id: 'outline', source: 'remix', labelKey: 'collectionDesign.iconSetOutline' },
  { id: 'duotone', source: 'phosphor', labelKey: 'collectionDesign.iconSetDuotone' },
  { id: 'handdrawn', source: 'khushmeen', labelKey: 'collectionDesign.iconSetHanddrawn' }
] as const;

/**
 * The icons each set is previewed with in the picker. All five exist in every
 * set, so no row renders a gap.
 */
export const ICON_SET_PREVIEW_SLUGS = ['save', 'send', 'download', 'cart', 'image'] as const;

export type IconSetId = typeof ICON_SETS[number]['id'];
export const DEFAULT_ICON_SET: IconSetId = ICON_SETS[0].id;
